import { render, staticRenderFns } from "./MagentoIntegration.pug?vue&type=template&id=16b21728&lang=pug&external"
import script from "./MagentoIntegration.js?vue&type=script&lang=js&external"
export * from "./MagentoIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports